// @flow

import type { UrlCriteria } from './_types';

const extractUrlCriteria = (url: string): UrlCriteria => {
    const criteria: UrlCriteria = {
        categoryId     : null,
        manufacturerId : null,
        adConditionId  : null,
        onlyRental     : false,
        min            : null,
        max            : null,
        sortType       : null,
        sortDirection  : null,
        advertiserId   : null
    };

    const { pathname } = new URL(url);
    if (pathname) {
        const resultCat = pathname.match(/cat:([0-9]+)/);
        if (resultCat) {
            const [, categoryId] = resultCat;
            criteria.categoryId = categoryId;
        }

        const resultMan = pathname.match(/man:([0-9]+)/);
        if (resultMan) {
            const [, manufacturerId] = resultMan;
            criteria.manufacturerId = manufacturerId;
        }

        const resultAdc = pathname.match(/adc:([0-9]+)/);
        if (resultAdc) {
            const [, adConditionId] = resultAdc;
            criteria.adConditionId = adConditionId;
        }

        const resultRent = pathname.match(/rent:(on)/);
        if (resultRent) {
            const [, onlyRental] = resultRent;
            criteria.onlyRental = onlyRental === 'on';
        }

        const resultMin = pathname.match(/min:([0-9]+)/);
        if (resultMin) {
            const [, min] = resultMin;
            criteria.min = min ? parseInt(min, 10) : null;
        }

        const resultMax = pathname.match(/max:([0-9]+)/);
        if (resultMax) {
            const [, max] = resultMax;
            criteria.max = max ? parseInt(max, 10) : null;
        }

        const sortType = pathname.match(/sor:([a-z]+)/);
        if (sortType) {
            const [, sor] = sortType;
            criteria.sortType = sor;
        }

        const sortDirection = pathname.match(/dir:([a-z]+)/);
        if (sortDirection) {
            const [, dir] = sortDirection;
            criteria.sortDirection = dir;
        }

        const resultAdv = pathname.match(/adv:([0-9]+)/);
        if (resultAdv) {
            const [, advertiserId] = resultAdv;
            criteria.advertiserId = advertiserId;
        }
    }

    return criteria;
};

export default extractUrlCriteria;
